module.exports = __webpack_public_path__ + "img/艾维-幸树.a4ecd321.png";